module.exports = __webpack_public_path__ + "img/arrow_up_circle.e9c76838.svg";